import React from "react";
import PortalHome from "Portal/PortalHome/View";

const PortalForms = () => {
  return <PortalHome scope="forms" />;
};

export default PortalForms;
